<template>
  <div id="kisaeIndex" class="dashboard-editor-container">
    <div id="tableWarp">
      <el-input v-model="deviceNameSearch" :placeholder="$t('AllDevices.SearchDeviceSn')" class="input-with-select deviceNameTable" clearable @clear="changeSearch(deviceNameSearch)">
        <el-button slot="append" icon="el-icon-search" @click="changeSearch()" />
      </el-input>
      <el-button icon="el-icon-plus" :title="$t('titles.addDevice')" style="vertical-align: top;margin: 10px;float: right;position: relative;z-index: 999;" type="primary" @click="add" />
    </div>
    <!-- 列表 -->
    <div v-for="(item,index) in tableData" :key="index">
      <div class="systemWarp">
        <div>
          <p class="systemTitleP">
            <span>
              <el-link style="font-size:18px;" type="primary" @click="goToDetailPage(item)">{{ item.yhubSn }}</el-link>
              &nbsp;&nbsp;&nbsp;&nbsp;{{ item.batteryModel }}&nbsp;&nbsp;&nbsp;&nbsp;{{ item.batteryCapacity }} Ah
            </span>
            <el-button icon="el-icon-delete" :title="$t('titles.delete')" size="mini" style="vertical-align: top;margin: -6px 0 0 10px;float: right;position: relative;z-index: 999;" type="primary" @click="deleteSystem(item)" />
            <el-button icon="el-icon-edit" :title="$t('titles.edit')" size="mini" style="vertical-align: top;margin: -6px 0 0 10px;float: right;position: relative;z-index: 999;" type="primary" @click="edit(item)" />
          </p>
          <div class="systemAllDiv" @click="goToDetailPage(item)">
            <div v-if="item.relationDeviceList.length==0" style="width: 100%;">No device connected</div>
            <div v-for="(device,index1) in item.relationDeviceList" v-else :key="index1" :class="index1!=item.relationDeviceList.length-1?'borderRight':''" class="divWarp">
              <!-- 设备类型：a yhub，b Inverter 双向逆变器，c CBB (单向逆变器)，d TC(AC充电器)，e DMT(DCDC充电器) -->
              <img v-if="device.deviceType=='d'" ref="acRef" alt src="@/assets/images/kisae/acCharge_online.png" style="width: 23%;">
              <img v-if="device.deviceType=='e'" alt src="@/assets/images/kisae/dcCharge_online.png" style="width: 30%;">
              <img v-if="device.deviceType=='b'" alt src="@/assets/images/kisae/bidirectional_online.png" style="width: 53%;margin: 8% 0;">
              <img v-if="device.deviceType=='c'" alt src="@/assets/images/kisae/inverter_online.png" style="width: 50%;margin: 6% 0;">
              <p>{{ device.name }}</p>
              <p style="font-size: 22px;">{{ device.deviceModel }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表模块————分页 -->
    <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
      <div class="pagination-container">
        <el-pagination v-if="pageshow" :page-size="listQuery.pageInfo.limit" :page-sizes="listQuery.pageInfo.pageList" :total="listQuery.pageInfo.total" background current-page.sync="listQuery.pageInfo.page" layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
      </div>
    </div>

    <!-- 新增系统--弹窗 -->
    <el-dialog id="addSystem" :close-on-click-modal="false" :visible.sync="addPopShow" title>
      <el-form ref="addSystem" :inline="true" :model="addSystemObj" :rules="popRule" class="demo-form-inline" label-width="150px">
        <!-- <el-form-item label="sn" prop="sn">
          <el-input v-model="addSystemObj.sn" />
        </el-form-item>-->
        <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="sn">
          <el-input v-model="addSystemObj.sn" :disabled="!isAdd" :placeholder="$t('BondOrUpdateDevice.FindSN')" @input="snChange(addSystemObj.sn)" />
          <!-- <el-autocomplete v-model="addSystemObj.sn" class="inline-input" style="width: 230px" :placeholder="$t('BondOrUpdateDevice.PleaseEnterSN')" :fetch-suggestions="querySearch" :trigger-on-focus="false" @input="change($event)" @select="handleSelectSN" /> -->
        </el-form-item>
        <el-form-item v-if="!isAdmin&&isAdd" :label="$t('BondOrUpdateDevice.Passcode')" prop="pcCode">
          <el-input v-model="addSystemObj.pcCode" :placeholder="$t('BondOrUpdateDevice.FindPC')" />
        </el-form-item>
        <el-form-item v-if="isAdmin" :label="$t('BondOrUpdateDevice.OwnedCompany')" class="redStart" prop="owncompany">
          <!--归属公司-->
          <el-select v-model="addSystemObj.company" :disabled="!isAdd||showBatteryModel" :placeholder="$t('AllDevices.companyName')" class="filter-item" clearable filterable @change="companySelect">
            <el-option v-for="(item,index) in companyOptions" :key="index" :label="item.companyName" :value="item.companyId" />
          </el-select>
          <p v-show="isShowOwnCompany" class="redWarningFont">Own company cannot be empty</p>
        </el-form-item>
        <el-form-item :label="$t('BondOrUpdateDevice.Model')" class="redStart" prop="batteryModel">
          <!-- 电池型号 -->
          <el-cascader v-if="!showBatteryModel" v-model="addSystemObj.model" :options="options2" :placeholder="$t('BondOrUpdateDevice.SelectBattery')" :show-all-levels="true" style="width: 280px" @change="batteryModelChange" />
          <el-cascader v-else v-model="addSystemObj.model" :options="options2" :placeholder="addSystemObj.batteryBrand + '/' + addSystemObj.batteryModel" :show-all-levels="true" style="width: 280px" @change="batteryModelChange" />
          <p v-show="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }}</p>
        </el-form-item>
        <el-form-item :label="$t('BondOrUpdateDevice.Capacity')" class="redStart" prop="capacity">
          <!-- 电池容量 -->
          <el-input v-model="addSystemObj.capacity" @blur="capacityBlur" @input="capacityChange" />
          <p v-show="isShowCapacityRequired" class="redWarningFont">{{ $t('BondOrUpdateDevice.EnterBatteryCapacity') }}</p>
          <p v-show="isShowCapacityNum" class="redWarningFont">Only numbers</p>
        </el-form-item>

        <el-form-item :label="$t('adminView.manufacturer')">
          <!--是否清空原始数据-->
          <el-radio
            v-model="addSystemObj.manufacturer"
            :label="1"
            @input="change($event)"
          >
            Kisae</el-radio>
          <el-radio
            v-model="addSystemObj.manufacturer"
            :label="2"
            @input="change($event)"
          >
            Enerdriver</el-radio>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closePop">Cancel</el-button>
        <el-button :disabled="disabledSubmit" type="primary" @click="submitBind('addSystem')">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageList, addDeviceBindSystemBase, updateDeviceBindSystemBase, deleteSystem, deviceBattery, querySearchSn, getLastMessageBootReq, cascader, listByCompanyParentId, getDMTCfg, getIvtCfg, getCBBCfg, getTCCfg } from '@/api/kisae'
import { addDeviceBindConfig, querySN } from '@/api/allDevice'
import { pagination } from '@/utils/init_table' // 分页
import i18n from '@/i18n'
import { arrObjSort } from '@/utils/arrayFun.js'
import vPinyin from '@/utils/pinyin-vue.js'

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      deviceNameSearch: '',
      tableData: [],
      tableData1: [
        {
          sn: '01192420340', mcuId: '05d6ff393430475043165127', name: 'AC-DC CHARGER', model: 'GPBT105', capacity: '105Ah',
          list: [
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC1205' },
            { type: 'dc', name: 'DC-DC CHARGER', model: 'DC1205' },
            { type: 'bid', name: 'INVERTER/CHARGER', model: 'IC1205' },
            { type: 'inv', name: 'INVERTER', model: 'SW1205' }
          ]
        },
        {
          sn: 121313, name: 'AC-DC CHARGER', model: 'GPBT105', capacity: '105Ah',
          list: [
            { type: 'bid', name: 'INVERTER/CHARGER', model: 'IC1205' },
            { type: 'inv', name: 'INVERTER', model: 'SW1205' }
          ]
        },
        {
          sn: 121313, name: 'AC-DC CHARGER', model: 'GPBT105', capacity: '105Ah',
          list: [
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC2048' },
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC2048' },
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC2048' },
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC2048' },
            { type: 'bid', name: 'INVERTER/CHARGER', model: 'IC1205' },
            { type: 'inv', name: 'INVERTER', model: 'SW1205' }
          ]
        },
        {
          sn: 121313, name: 'AC-DC CHARGER', model: 'GPBT105', capacity: '105Ah',
          list: [
            { type: 'ac', name: 'AC-DC CHARGER', model: 'AC2048' },
            { type: 'bid', name: 'INVERTER/CHARGER', model: 'IC1205' },
            { type: 'inv', name: 'INVERTER', model: 'SW1205' }
          ]
        }
      ],
      bidTypeArr: [
        { value: '0', label: 'GPIC1230100-KS-01' },
        { value: '1', label: 'GPIC1220080-KS-01' },
        { value: '2', label: 'GPIC1230100I-KS-01' },
        { value: '3', label: 'GPIC1220080I-KS-01' },
        { value: '4', label: 'GPIC2430050-KS-01' },
        { value: '5', label: 'GPIC2420040-KS-01' },
        { value: '6', label: 'GPIC2430050I-KS-01' },
        { value: '7', label: 'GPIC2420040I-KS-01' },
        { value: '10', label: 'GPIC1225050-KS-01' },
        { value: '11', label: 'GPIC1225050I-KS-01' },
        { value: '12', label: 'GPIC2425050-KS-01' },
        { value: '13', label: 'GPIC2425050I-KS-01' },
        { value: '14', label: 'GPIC1230100-KS-01' }
      ],
      invTypeArr: [
        { value: '1', label: 'GPCB1012' },
        { value: '2', label: 'CB01100002-KS-EU' },
        { value: '3', label: 'CB01100002-KS-UK' },
        { value: '4', label: 'CB01100002-KS-AU' },
        { value: '5', label: 'CB02100001-KS-01' },
        { value: '6', label: 'CB02100002-KS-EU' },
        { value: '7', label: 'CB02100002-KS-UK' },
        { value: '8', label: 'CB02100002-KS-AU' },
        { value: '9', label: 'CB01200001-KS-01' },
        { value: '10', label: 'CB01200002-KS-EU' },
        { value: '11', label: 'CB01200002-KS-UK' },
        { value: '12', label: 'CB01200002-KS-AU' },
        { value: '13', label: 'CB02200001-KS-01' },
        { value: '14', label: 'CB02200002-KS-EU' },
        { value: '15', label: 'CB02200002-KS-UK' },
        { value: '16', label: 'CB02200002-KS-AU' },
        { value: '17', label: 'CB01300001-KS-01' },
        { value: '18', label: 'CB01300002-KS-EU' },
        { value: '19', label: 'CB01300002-KS-UK' },
        { value: '20', label: 'CB01300002-KS-AU' },
        { value: '21', label: 'CB02300001-KS-01' },
        { value: '22', label: 'CB02300002-KS-EU' },
        { value: '23', label: 'CB02300002-KS-UK' },
        { value: '24', label: 'CB02300002-KS-AU' }
      ],
      // 弹窗----start
      addPopShow: false, // 弹窗
      disabledSubmit: true,
      addSystemObj: {
        capacity: '',
        batteryBrand: '',
        batteryModel: '',
        sn: '',
        manufacturer: ''
      },
      isShowCapacityNum: false,
      isShowCapacityRequired: false,
      popRule: {
        sn: [{ required: true, message: i18n.t('BondOrUpdateDevice.SNNotFound'), trigger: 'blur' }], // 序列号不能为空
        pcCode: [{ required: true, message: i18n.t('BondOrUpdateDevice.IncorrectPasscode'), trigger: 'blur' }]
        // capacity: [
        //   { required: true, message: i18n.t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }
        //   // { type: 'number', message: '只能输入数字' }
        // ]
      },
      options2: [], // 弹窗--电池型号下拉框
      isShowBatteryModelWarning: false,
      isShowOwnCompany: false,
      companyOptions: [], // 编辑设备信息弹窗--归属公司下拉框
      isAdmin: this.$store.state.isAdmin,
      companylistQuery: {
        pageInfo: {
          pageNum: 1,
          pageSize: 10000,
          pageNo: 1,
          total: 0,
          pageList: [10, 20, 30, 50]
        }
      },
      isAdd: true,
      showBatteryModel: false, // 是否展示电池型号默认值
      bindDeviceTypeArr: [] // sn绑定的设备类型
      // 弹窗----end
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.queryList()
    //  监听窗口大小改变图表大小（先移除再监听，防止出错）
    window.removeEventListener('resize', this.resizePerformanceFun)
    window.addEventListener('resize', this.resizePerformanceFun)
    this.initPop()
  },
  created() {},
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.resizePerformanceFun)
  },
  methods: {
    queryList() {
      var param = {
        companyId: '',
        deviceTypeList: [],
        key: this.deviceNameSearch,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(response => {
        //   // console.log(response)
        this.tableData = response.resultModel.list
        this.tableData.forEach(v => {
          if (v.relationDeviceList) {
            if (v.batteryCapacity > 1000) { v.batteryCapacity = Math.round(v.batteryCapacity / 100) }
            v.relationDeviceList.forEach((m, i) => {
              //  设备类型：a yhub，b Inverter 双向逆变器，c CBB (单向逆变器)，d TC(AC充电器)，e DMT(DCDC充电器) -->
              // console.log('m-------', m)
              //  设备类型：a yhub，b Inverter 双向逆变器，c CBB (单向逆变器)，d TC(AC充电器)，e DMT(DCDC充电器)
              switch (m.deviceType) {
                case 'b': m.name = 'INVERTER/CHARGER'; this.bidTypeArr.forEach(v => { if (m.deviceModel == v.value) m.deviceModel = v.label }); break
                case 'c': m.name = 'INVERTER'; this.invTypeArr.forEach(v => { if (m.deviceModel == v.value) m.deviceModel = v.label }); break
                case 'd': m.name = 'AC-DC CHARGER'; m.deviceModel = 'AC ' + Number(m.deviceModel).toString(16); break
                case 'e': m.name = 'DC-DC CHARGER'; m.deviceModel = 'DMT ' + Number(m.deviceModel).toString(16); break
                default:v.relationDeviceList.splice(i, 1)
              }
            })
          }
          // v.list = this.tableData1[0].list
        })
        this.listQuery.pageInfo.total = response.resultModel.total // 分页
      })
    },
    // 筛选改变事件
    changeSearch(inputDevName) {
      if (this.deviceNameSearch) {
        // 去掉首尾空格
        this.deviceNameSearch = this.deviceNameSearch.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    capacityChange() {
      if (this.addSystemObj.capacity) {
        this.addSystemObj.capacity = this.addSystemObj.capacity.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      if (this.addSystemObj.capacity) {
        this.isShowCapacityRequired = false
        if (/^\+?[1-9][0-9]*$/.test(this.addSystemObj.capacity) == false) {
          this.isShowCapacityNum = true
        } else {
          this.isShowCapacityNum = false
        }
      }
    },
    capacityBlur() {
      if (!this.addSystemObj.capacity) {
        this.isShowCapacityRequired = true
      } else {
        this.isShowCapacityRequired = false
      }
    },
    change(e) {
      this.$forceUpdate()
    },
    add() {
      // 弹窗--弹窗显示
      this.addPopShow = true
      this.showBatteryModel = false
      this.addSystemObj = {
        model: [],
        capacity: '',
        batteryId: '',
        batteryModel: '',
        manufacturer: ''
      }
      this.isAdd = true
      if (this.$store.state.isAdmin) {
        this.isAdmin = true
      } else {
        this.isAdmin = false
      }
    },
    querySearch(queryString, cb) {
      // 弹窗--序列号下拉框数据
      querySearchSn(queryString).then(response => {
        var restaurants = response.resultModel
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants
        // console.log(results)
        if (results.length < 1) {
          this.disabledSubmit = true
          this.$notify({
            title: '',
            message: 'Please enter the correct sn',
            type: 'warning',
            duration: 2000
          })
        } else {
          this.disabledSubmit = false
        }
        cb(results)
        if (results && results.length == 1) {
          this.$set(this.addSystemObj, 'mcuId', results[0].mcu)
        }
      })
    },
    createFilter(queryString) {
      return restaurant => {
        // console.log('restaurant--', restaurant)
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    snChange(val) {
      if (val.length >= 11 || (val.length == 10 && val[0] == 'P')) {
        // 如：PY01000330
        if (this.addSystemObj.sn) {
          // 去掉首尾空格
          this.addSystemObj.sn = this.addSystemObj.sn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
        }
        querySN({ sn: this.addSystemObj.sn }).then(res => {
          if (res.resultCode == 1001) {
            if (!res.resultModel) {
              this.disabledSubmit = true
              this.$notify({
                title: '',
                message: i18n.t('AllDevices.enterCorrectsn'),
                type: 'warning',
                duration: 3000
              })
            } else {
              // this.$notify({
              //   title: '',
              //   message: 'sn correct',
              //   type: 'success',
              //   duration: 1000
              // })
              getLastMessageBootReq({ mcuId: res.resultModel.yhubMcu }).then(response => {
                if (response.resultCode == 1001) {
                  if (
                    response.resultModel &&
                      response.resultModel.fwVersion
                  ) {
                    this.addSystemObj.fwversion =
                        response.resultModel.fwVersion
                  }
                }
              })
              this.$set(this.addSystemObj, 'mcuId', res.resultModel.yhubMcu)
              this.disabledSubmit = false
              if (res.resultModel.bindInfoList.length == 0) {
                // 未绑定
                this.disabledSubmit = false
                this.addSystemObj.bindInfoList = []
                this.showBatteryModel = false
              } else {
                // 已绑定
                this.firstAdd = false
                this.addSystemObj.bindInfoList = res.resultModel.bindInfoList
                var companyIds = [] // 当前公司及子公司id的集合
                var types = [] // 已绑定的类型的集合
                this.companyOptions.forEach(v => {
                  companyIds.push(v.companyId)
                })
                // if(res.resultModel.bindInfoList.length>1){//一定绑定了kisae
                var bindCompanyNameE
                res.resultModel.bindInfoList.forEach((v, i) => {
                  if (v.deviceType.indexOf('k') > -1) {
                    if (companyIds.indexOf(v.companyId) == -1) {
                      // 被非己及子公司绑定
                      bindCompanyNameE = '其他公司'
                      if (this.$store.state.language != 'zh' && this.$store.state.language != 'ft') { bindCompanyNameE = 'other companies' }
                    } else {
                      bindCompanyNameE = ' [ ' + v.companyName + ' ] '
                    }
                  }
                  if (v.deviceType.indexOf(',') > -1) {
                    var a = v.deviceType.split(',')
                    types = types.concat(a)
                  } else {
                    types.push(v.deviceType)
                  }
                })
                this.bindDeviceTypeArr = types
                this.addSystemObj.bindId = res.resultModel.bindInfoList[0].id
                if (res.resultModel.bindInfoList.length == 2) {
                  // 必定已经绑带Kisae了
                  this.$notify({
                    title: '',
                    message: '已被' + bindCompanyNameE + '绑定 Kisae 功能，请先解绑',
                    type: 'warning',
                    duration: 4000
                  })
                  if (this.$store.state.language == 'zh') {
                    this.$notify({
                      title: '',
                      message: '已被' + bindCompanyNameE + '绑定 Kisae 功能，请先解绑！',
                      type: 'warning',
                      duration: 4000
                    })
                  } else if (this.$store.state.language == 'ft') {
                    this.$notify({
                      title: '',
                      message: '已被' + bindCompanyNameE + '綁定 Kisae 功能，請先解綁！',
                      type: 'warning',
                      duration: 4000
                    })
                  } else {
                    this.$notify({
                      title: '',
                      message: 'Kisae function has been bound by ' + bindCompanyNameE + ', please unbind it first!',
                      type: 'warning',
                      duration: 4000
                    })
                  }
                  this.showBatteryModel = false
                  this.disabledSubmit = true
                } else {
                  // 未绑定kisae
                  var bindInfoList0 = res.resultModel.bindInfoList[0]
                  var name
                  if (bindInfoList0.deviceType.indexOf(',') > -1 || bindInfoList0.deviceType.indexOf('k') > -1 || types.indexOf('e') > -1 || types.indexOf('c') > -1) {
                    // 不可以绑定,已经被lithium/controller/kisae绑定
                    if (types.indexOf('e') > -1) {
                      name = 'Lithium'
                    }
                    if (types.indexOf('c') > -1) {
                      name = 'Controller'
                    }
                    if (types.indexOf('k') > -1) {
                      name = 'Kisae'
                    }
                    if (companyIds.indexOf(bindInfoList0.companyId) == -1) {
                      // 被非己及子公司绑定
                      bindCompanyNameE = '其他公司'
                      if (this.$store.state.language != 'zh' && this.$store.state.language != 'ft') { bindCompanyNameE = 'other companies' }
                    } else {
                      bindCompanyNameE = ' [ ' + bindInfoList0.companyName + ' ] '
                    }
                    if (this.$store.state.language == 'zh') {
                      this.$notify({
                        title: '',
                        message: '已被' + bindCompanyNameE + '绑定 ' + name + ' 功能，请先解绑！',
                        type: 'warning',
                        duration: 4000
                      })
                    } else if (this.$store.state.language == 'ft') {
                      this.$notify({
                        title: '',
                        message: '已被' + bindCompanyNameE + '绑定 ' + name + ' 功能，请先解绑！',
                        type: 'warning',
                        duration: 4000
                      })
                    } else {
                      this.$notify({
                        title: '',
                        message: name + ' function has been bound by ' + bindCompanyNameE + ', please unbind it first!',
                        type: 'warning',
                        duration: 4000
                      })
                    }
                    this.showBatteryModel = false
                    this.disabledSubmit = true
                  } else {
                    // 可以绑定
                    this.disabledSubmit = false
                    this.addSystemObj.company = bindInfoList0.companyId
                    this.addSystemObj.companyId = bindInfoList0.companyId
                    this.addSystemObj.deviceName = bindInfoList0.deviceName
                    // this.addSystemObj.deviceSn = bindInfoList0.deviceSn
                    this.addSystemObj.batteryModel = bindInfoList0.batteryModel
                    this.addSystemObj.batteryId = bindInfoList0.batteryId
                    this.addSystemObj.batteryModel = bindInfoList0.batteryModel
                    this.addSystemObj.batteryBrand = bindInfoList0.batteryBrand
                    // this.addSystemObj.batteryTotalah = bindInfoList0.batteryCapacity
                    // this.addSystemObj.batterySystemVolt = bindInfoList0.batteryVoltage
                    if (res.resultModel.lastYhubConfig.batterySystemVolt) {
                      this.addSystemObj.batterySystemVolt = res.resultModel.lastYhubConfig.batterySystemVolt > 100 ? res.resultModel.lastYhubConfig.batterySystemVolt / 100 : res.resultModel.lastYhubConfig.batterySystemVolt
                    } else {
                      this.addSystemObj.batteryVoltage = '24'
                    }
                    if (res.resultModel.lastYhubConfig.batteryTotalah) {
                      this.addSystemObj.capacity = res.resultModel.lastYhubConfig.batteryTotalah > 1000 ? Math.round(res.resultModel.lastYhubConfig.batteryTotalah / 100) : res.resultModel.lastYhubConfig.batteryTotalah
                    } else {
                      this.addSystemObj.capacity = '225'
                    }
                    this.$forceUpdate()
                    this.showBatteryModel = true
                  }
                }
                this.bindDeviceTypeArr.push('a')
              }
            }
          }
        })
      }
    },
    // 弹窗--初始化
    initPop() {
      cascader().then(response => {
        // 弹窗--电池型号下拉框
        this.options2 = response.resultModel
      })
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))

      listByCompanyParentId({ companyParentId: sessionCompany.id }).then(
        response => {
          if (response.resultCode == 1001) {
            this.companyOptions = []
            if (response.resultModel && response.resultModel.length > 1) {
              this.haveChildCompany = true
            } else {
              this.haveChildCompany = false
            }
            response.resultModel.forEach(v => {
              if (v.companyName) {
                this.companyOptions.push({
                  companyName: v.companyName,
                  companyId: v.id
                })
              }
            })
            this.companyOptionsFun()
          }
        }
      )
    },
    companyOptionsFun() {
      var sessionCompany = JSON.parse(sessionStorage.getItem('companyInfo'))
      // 将归属公司转拼音进行排序
      this.companyOptions.forEach(v => {
        if (v.companyName[0] >= 'a' && v.companyName[0] <= 'z') {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName.toUpperCase())
        } else {
          v.namePinyin = vPinyin.chineseToPinYin(v.companyName)
        }
      })
      this.companyOptions.sort(arrObjSort('namePinyin'))
      var hadSelfCompany = false // 是否包含自己所在公司。因为受域名限制，可能不展示自己所在公司
      // 排序后，自己公司可能不在首位，所以先删除，再添加
      this.companyOptions.forEach((v, i) => {
        if (v.companyId == sessionCompany.id) {
          hadSelfCompany = true
          this.companyOptions.splice(i, 1)
        }
      })
      if (hadSelfCompany) {
        this.companyOptions.unshift({
          companyName: sessionCompany.companyName,
          companyId: sessionCompany.id
        })
      }
    },
    companySelect(query) {
      // 弹窗--公司信息选中
      for (const key2 in this.companyOptions) {
        const company = this.companyOptions[key2]
        if (query === company.companyId) {
          this.addSystemObj.companyName = company.companyName
          this.addSystemObj.companyId = company.companyId
          break
        }
      }
      this.isShowOwnCompany = false
    },
    handleSelectSN(item) {
      // 弹窗--序列号选中
      // console.log(item)
      getLastMessageBootReq({ sn: this.addSystemObj.sn }).then(res => {
        if (res.data && res.data.fwversion) { this.addSystemObj.fwversion = res.data.fwversion }
      })
      this.addSystemObj.mcuId = item.mcu
    },
    batteryModelChange(value) {
      // 弹窗--电池型号选中
      // console.log('value========', value)
      if (!value) return
      this.addSystemObj.capacity = value[1].batteryAh
      this.addSystemObj.batteryId = value[1].id
      this.addSystemObj.batteryModel = value[1].batteryModel
      this.addSystemObj.manufacturer = value[1].manufacturer
      this.isShowBatteryModelWarning = false
    },
    edit(item) {
      console.log(item)
      this.addPopShow = this.showBatteryModel = true
      this.isAdd = false
      this.disabledSubmit = false
      this.addSystemObj.id = item.id
      this.addSystemObj.mcuId = item.mcuId
      this.addSystemObj.sn = item.yhubSn
      this.addSystemObj.company = item.companyId
      this.addSystemObj.companyId = item.companyId
      this.addSystemObj.capacity = item.batteryCapacity
      this.addSystemObj.mechBrand = item.mechBrand
      this.addSystemObj.mechModel = item.mechModel
      this.addSystemObj.mechId = item.mechId
      this.addSystemObj.manufacturer = item.manufacturer
      // this.addSystemObj.batteryModel = item.batteryModel
      this.addSystemObj.batteryId = item.batteryId
      deviceBattery({ id: item.batteryId }).then(response => {
        if (response.resultCode == 1001) {
          this.addSystemObj.batteryBrand = response.resultModel.batteryBrand
          this.addSystemObj.batteryModel = response.resultModel.batteryModel
        }
      })
    },
    deleteSystem(item) {
      this.$confirm('Are you sure to delete this piece of system information？', '', { //
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteSystem({ id: item.id }).then(res => {
          if (res.resultCode == '1001') {
            this.$message({
              type: 'success',
              message: i18n.t('warningSet.submitted')
            })
            this.queryList()
          }
        })
      }).catch(() => {})
    },
    closePop() {
      // this.addSystemObj = { model: [] }
      this.addPopShow = this.isShowCapacityRequired = this.isShowCapacityNum = false
    },
    submitBind(formName) {
      // 弹窗--提交
      // console.log(this.deviceTypeArr)
      var param = {
        batteryCapacity: this.addSystemObj.capacity * 100,
        batteryId: this.addSystemObj.batteryId,
        batteryModel: this.addSystemObj.batteryModel,
        companyId: this.addSystemObj.companyId,
        deviceType: 'a',
        mcuId: this.addSystemObj.mcuId,
        remark: '',
        yhubPc: this.addSystemObj.pcCode || '',
        yhubSn: this.addSystemObj.sn,
        mechId: 1,
        manufacturer: this.addSystemObj.manufacturer
      }
      if (!this.addSystemObj.batteryId) {
        this.isShowBatteryModelWarning = true
        return
      }
      var yhubConfig = {
        batteryId: this.addSystemObj.batteryId,
        batterySystemVolt: 24,
        batteryTotalah: this.addSystemObj.capacity * 100,
        canFuntion: 4,
        configFrom: 201,
        configVersion: this.addSystemObj.fwversion || 201,
        extralFuntion: 0,
        gprsApnName: '263.cs101',
        hallDirection: 0,
        hallSensorRange: 0,
        ledSetting: 0,
        locationSample: 60,
        sensorType: 1,
        supportRelaycontrol: 0,
        supportWaterlevel: 1,
        mcuId: this.addSystemObj.mcuId
      }
      if (this.isShowCapacityRequired || this.isShowCapacityNum) return
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.addSystemObj.companyId && this.isAdmin) {
            this.isShowOwnCompany = true
            return
          }
          console.log('success submit!!')
          if (this.isAdd) {
            addDeviceBindSystemBase(param).then(response => {
              if (response.resultCode === 1001) {
                if (!this.addSystemObj.fwversion || Number(this.addSystemObj.fwversion) < 200) {
                  console.log('fwversion---', this.addSystemObj.fwversion)
                  this.$alert(i18n.t('AllDevices.UpdateFailed'), '', {
                    confirmButtonText: i18n.t('button.Confirm'),
                    callback: action => {}
                  })
                } else {
                  this.$notify({
                    title: '',
                    message: i18n.t('warningSet.submitted'),
                    type: 'success',
                    duration: 2000
                  })
                }
                getDMTCfg({ mcuId: this.addSystemObj.mcuId }).then(res => {})
                getIvtCfg({ mcuId: this.addSystemObj.mcuId }).then(res => {})
                getCBBCfg({ mcuId: this.addSystemObj.mcuId }).then(res => {})
                getTCCfg({ mcuId: this.addSystemObj.mcuId }).then(res => {})
                this.queryList()
                this.addPopShow = false
                addDeviceBindConfig(yhubConfig).then(response => {})
              } else if (response.resultCode == 6001) {
                // this.$message.error('绑定失败,PC码错误')
                this.$message.error(response.resultMessage)
              } else {
                this.$message.error('Failed')
              }
            })
          } else {
            param.id = this.addSystemObj.id
            // param.deviceType = this.bindDeviceTypeArr.toString()
            updateDeviceBindSystemBase(param).then(response => {
              if (response.resultCode === 1001) {
                if (!this.addSystemObj.fwversion || Number(this.addSystemObj.fwversion) < 200) {
                  console.log('fwversion---', this.addSystemObj.fwversion)
                  // this.$alert(i18n.t('AllDevices.UpdateFailed'), '', {
                  //   confirmButtonText: i18n.t('button.Confirm'),
                  //   callback: action => {
                  //   }
                  // })
                } else {
                  this.$notify({
                    title: '',
                    message: i18n.t('warningSet.submitted'),
                    type: 'success',
                    duration: 2000
                  })
                }
                this.queryList()
                this.addPopShow = false
              } else {
                this.$message.error('Failed')
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    goToDetailPage(row) {
      sessionStorage.setItem('kisaeRelationDeviceList', JSON.stringify(row.relationDeviceList))
      var routeData = this.$router.resolve({
        path: '/kisae/kisaeDetail',
        query: {
          mcuId: row.mcuId
          // name: rAC-DC CHARGEReviceSn,
          // id: row.id,
        }
      })
      window.open(routeData.href, '_self')
    },
    resizePerformanceFun() {
      // console.log('1')
      // console.log(this.$el.getBoundingClientRect())
      // console.log(this.$refs.acRef[0].clientHeight)
      // for (var i = 0; i < document.querySelectorAll('.divWarp').length; i++) {
      //   document.querySelectorAll('.divWarp')[i].style.height = this.$refs.acRef[0].clientHeight + 'px'
      // }
    },
    // 分页----start
    handleSizeChange(val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
#kisaeIndex {
  height: 100%;
  .systemWarp {
    background: #fff;
    margin: 20px 0;
    padding: 20px;
    .systemTitleP {
      background: #e6e9ed;
      padding: 10px;
    }
    .systemAllDiv {
      width: 100%;
      cursor: pointer;
      p {
        line-height: 28px;
        font-weight: bold;
      }
    }
    .systemAllDiv > div {
      width: 25%;
      display: inline-block;
      text-align: center;
      margin: 20px 0;
      vertical-align: top;
    }
    .borderRight {
      border-right: 1px solid #d4d5d6;
    }
    .line {
      width: 1px;
      height: 100%;
      border-right: 1px solid red;
    }
    // .systemAllDiv>div img{
    //   width: 30%;
    // }
  }
  .systemWarp > div {
    border: 1px solid gray;
  }
}
</style>
<style lang="scss">
#kisaeIndex {
  #tableWarp .el-input-group {
    width: 40% !important;
    max-width: 400px !important;
    margin-top: 13px;
  }
  #addSystem .el-form-item--medium .el-form-item__content {
    width: 280px;
  }
  #addSystem .el-select--medium {
    width: 100%;
  }
}
</style>
